//Generated File 
export default class ViewMode{
	static readonly EDIT = `EDIT`;
	static readonly NEW = `NEW`;
	static readonly VIEW = `VIEW`;
}
